import { Component, Input } from "@angular/core";
import { DatatableComponent } from "../datatable/datatable.component";

@Component({
	selector: "app-order-column-icon",
	templateUrl: "./order-column-icon.component.html",
	styleUrls: ["./order-column-icon.component.scss"],
	standalone: false
})
export class OrderColumnIconComponent {
	@Input() prop = "";
	@Input() title = "";
	@Input() sortable = true;

	constructor(public table: DatatableComponent) {}

	orderColumn(): void {
		if (this.sortable && this.prop) {
			this.table.orderBy(this.prop);
		}
	}
}
